export { default } from './useWindow';
export * from './useWindow';
